import React, {useState} from 'react';
import {Menu, Dropdown, Button, Layout} from 'antd';
import {UserOutlined} from '@ant-design/icons';
import {Link, useNavigate} from 'react-router-dom';
import {LocalStorage} from '../LocalStorage';
import {colors} from '../theme';
const {Header} = Layout;

const menuLink = (label: string, path: string) => ({
  label: <Link to={path}>{label}</Link>,
  key: path,
});

const NavBar = () => {
  const [current, setCurrent] = useState('productos');
  const navigate = useNavigate();

  const onClick = (e: any) => {
    setCurrent(e.key);
  };

  const logout = () => {
    LocalStorage.clearAll();
    navigate('/login', {replace: true});
  };

  const userMenuItems = [
    {key: 'profile', label: <Link to="/profile">Profile</Link>},
    {key: 'logout', label: 'Logout', onClick: logout},
  ];

  return (
    <Header
      style={{
        position: 'fixed',
        zIndex: 999,
        width: '100%',
        backgroundColor: colors.navbar,
        borderBottom: `1px solid ${colors.navbarBorder}`,
        boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <div style={{flex: 1, flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
          <Link to="/ingredients" style={{display: 'flex', alignItems: 'center', marginRight: 24}}>
            <img
              src={require('../assets/umbrella-logo.png')}
              alt="Logo"
              style={{height: 40, cursor: 'pointer'}}
            />
          </Link>
          <Menu
            onClick={onClick}
            selectedKeys={[current]}
            mode="horizontal"
            style={{backgroundColor: 'transparent', flex: 1, borderBottom: 'none'}}
            items={[
              {
                label: 'Ingredients',
                key: 'productos',
                children: [
                  menuLink('Add new ingredient', '/ingredients/new'),
                  menuLink('Ingredient list', '/ingredients'),
                ],
              },
              {
                label: 'Actives',
                key: 'actives',
                children: [
                  menuLink('Add new active', '/actives/new'),
                  menuLink('Active list', '/actives'),
                ],
              },
              {
                label: 'Warnings',
                key: 'warnings',
                children: [
                  menuLink('Add new warning', '/warnings/new'),
                  menuLink('Warnings list', '/warnings'),
                ],
              },
              {
                label: 'Claims',
                key: 'claims',
                children: [
                  menuLink('Add new claim', '/claims/new'),
                  menuLink('Claims list', '/claims'),
                ],
              },
              {
                label: 'Statics',
                key: 'statics',
                children: [menuLink('Statics list', '/statics')],
              },
              {
                label: 'Formulation',
                key: 'formulation',
                children: [
                  menuLink('Add new formulation', '/formulations/new'),
                  menuLink('Formulation list', '/formulations'),
                ],
              },
            ]}
          />
        </div>

        <Dropdown menu={{items: userMenuItems}} trigger={['click']}>
          <Button shape="circle" icon={<UserOutlined />} />
        </Dropdown>
      </div>
    </Header>
  );
};

export default NavBar;
